import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToasterService } from 'angular2-toaster/angular2-toaster';
import { Observable } from 'rxjs/Observable';
import { CommonService } from './common.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class HttpService {
    constructor(
        private http: HttpClient,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private router: Router
    ) {}

    get(url: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http.get(url, {params: params})
            .map((res: Response) => this.handleSuccess(res))
            .catch(err => this.handleErrors(err));
    }

    post(url: string, payload: Object = {}, params: HttpParams = new HttpParams()): Observable<any> {
        const formData: FormData = new FormData();
        for (const item in payload) {
            if (payload.hasOwnProperty(item)) {
                formData.append(item, payload[item]);
            }
        }

        return this.http.post(url, formData, {params: params})
            .map((res: Response) => this.handleSuccess(res))
            .catch(err => this.handleErrors(err));
    }

    patch(url: string, payload: Object = {}, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http.patch(url, payload, {params: params})
            .map((res: Response) => this.handleSuccess(res))
            .catch(err => this.handleErrors(err));
    }

    delete(url: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http.delete(url, {params: params})
            .map((res: Response) => this.handleSuccess(res))
            .catch(err => this.handleErrors(err));
    }

    put(url: string, payload: Object = {}, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http.put(url, payload, {params: params})
            .map((res: Response) => this.handleSuccess(res))
            .catch(err => this.handleErrors(err));
    }

    private handleSuccess(resp: Response) {
        if (resp['notifs']) {
            this.commonService.setNotifsData(resp['notifs']);
        }
        if (resp['notices']) {
            this.commonService.setNoticesData(resp['notices']);
        }
        return resp;
    }

    private handleErrors(err: Response): Observable<any> {
        switch (err.status) {
            case 400:
                // Bad Request
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;

            case 401:
                // Token Expired OR Unauthorized Access
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                this.router.navigate(['/lock']);
                break;

            case 403:
                // Forbidden
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;

            case 404:
                // Resource Not Found
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;

            case 422:
                // Resource Not Found
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;

            case 429:
                // Too Many Requests
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;

            case 440:
                this.router.navigate(['/logout'], {queryParams: { domaincheck : true}});
                break;

            case 500:
                // Internal Server Error
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;

            default:
                this.toasterService.pop('error', 'Error', err['error'].error.message);
                break;
        }

        return Observable.of(err['error']);
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/http.service.ts